import SectionErrorRoute from 'garaje/utils/section-error-route';

export default class ResourcesErrorRoute extends SectionErrorRoute {
  section = 'resources';
}
